import {enableProdMode, importProvidersFrom, provideZonelessChangeDetection} from '@angular/core';


import {environment} from './environments/environment';
import {JWT_OPTIONS, JwtHelperService} from '@auth0/angular-jwt';
import {DatePipe} from '@angular/common';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr} from '@angular/common/http';
import {JwtInterceptor} from './app/api/interceptors/jwt.interceptor';
import {bootstrapApplication, BrowserModule} from '@angular/platform-browser';
import {AppRoutingModule} from './app/app-routing.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {provideAnimations} from '@angular/platform-browser/animations';

import {AppComponent} from './app/app.component';
import {provideWaToasts} from "angular-awesome";

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(BrowserModule, AppRoutingModule, FormsModule, ReactiveFormsModule),
    JwtHelperService,
    DatePipe,
    {
      provide: JWT_OPTIONS,
      useValue: JWT_OPTIONS
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true
    },
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideAnimations(),
    provideWaToasts({placement: "top-center", max:3, duration:4000, newestOnTop:true}),
    provideZonelessChangeDetection()
  ]
})
  .catch(err => console.error(err));
